export default {
  allDeviceRegistrations: (state) => state.deviceRegistrations,
  filter: (state) => state.filter
}
